import axios from 'axios'
import { CLIENTES_ENDPOINT } from 'cfgCommon/endpoints'

export async function addClient(client) {
  const response = await axios.post(`${CLIENTES_ENDPOINT}`, client)
  return response?.data?.data
}
